import { requestJson } from "../api/apiClient";

const BASE = "/api/weather/commercial";

export async function fetchWeatherWatches(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value != null && value !== "") {
      params.set(key, String(value));
    }
  });
  const query = params.toString();
  return requestJson(`${BASE}/watches${query ? `?${query}` : ""}`);
}

export async function createWeatherWatch(body) {
  return requestJson(`${BASE}/watches`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function updateWeatherWatch(watchId, body) {
  return requestJson(`${BASE}/watches/${encodeURIComponent(watchId)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export async function deleteWeatherWatch(watchId) {
  return requestJson(`${BASE}/watches/${encodeURIComponent(watchId)}`, {
    method: "DELETE",
  });
}

export async function fetchWeatherWatchEvents(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value != null && value !== "") {
      params.set(key, String(value));
    }
  });
  const query = params.toString();
  return requestJson(`${BASE}/watch-events${query ? `?${query}` : ""}`);
}

export async function acknowledgeWeatherWatchEvent(eventId, status = "acknowledged") {
  return requestJson(`${BASE}/watch-events/${encodeURIComponent(eventId)}`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
}

export async function fetchPropertyWeatherReport(propertyId) {
  return requestJson(`${BASE}/reports/property/${encodeURIComponent(propertyId)}`);
}

export async function fetchPointWeatherReport({ lat, lng, radiusMeters }) {
  const params = new URLSearchParams({
    lat: String(lat),
    lng: String(lng),
  });
  if (radiusMeters != null) {
    params.set("radiusMeters", String(radiusMeters));
  }
  return requestJson(`${BASE}/reports/point?${params.toString()}`);
}
